import styled from "styled-components";

import type { Progress } from "@mainion/protocol";

import { Muted } from "./primitives.tsx";

const Bar = styled.div`
    height: 6px;
    border-radius: 3px;
    background: var(--border);
    overflow: hidden;
`;

const Fill = styled.div`
    height: 100%;
    background: var(--accent);
    transition: width 0.3s;
`;

/** The worker's latest progress message, with a bar if it said how many steps there are. */
export function ProgressView({ progress }: { progress: Progress }) {
    const { message, done, total } = progress;
    const counted = done !== undefined && total ? ` (${done}/${total})` : "";

    return (
        <div>
            <Muted>
                {message}
                {counted}
            </Muted>
            {done !== undefined && total ? (
                <Bar>
                    <Fill style={{ width: `${Math.min(100, (done / total) * 100)}%` }} />
                </Bar>
            ) : null}
        </div>
    );
}
